import { Delete, UploadFile } from "@mui/icons-material";
import { Button, Checkbox, Divider, FormControl, Grid, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect } from "react";

const MotivationStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <TextField
                    placeholder="Please give a short description (max 200 words) of why you want to become a SPICE expert and how you believe your expertise and knowledge would be beneficial to your peers in low-resource facilities"
                    label="Motivation for joining the registry"
                    id="outlined-size-small"
                    name="motivation"
                    multiline
                    rows={5}
                    maxRows={10}
                    fullWidth
                    value={props.formData.motivation}
                    helperText={props.emptyFormProps.includes('motivation') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('motivation')}
                    onChange={props.handleInputChange}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>
            {/* <Grid item xs={12} sm={12}>
                <FormControl fullWidth size="small">
                    <InputLabel id="supprot-select-label">Areas of support</InputLabel>
                    <Select
                        labelId="support-select-label"
                        multiple
                        value={props.formData.registry_related_experience}
                        onChange={props.handleRegistryRelatedExperienceChange}
                        input={<OutlinedInput label="Areas of support" />}
                        renderValue={(x) =>
                            props.registryRelatedExperienceValues
                                .filter(y => x.includes(y.id))
                                .map(el => el.value)
                                .join(', ')
                        }
                    >
                        {props.registryRelatedExperienceValues
                            .map((el) => (
                                <MenuItem key={el.id} value={el.id}>
                                    <Checkbox checked={props.formData.registry_related_experience.includes(el.id)} />
                                    <ListItemText primary={el.value} />
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid> */}
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    component="label"
                    startIcon={<UploadFile />}
                    fullWidth
                    sx={{ textTransform: 'none', marginBottom: '2.5vh', marginTop: '2.5vh' }}
                >
                    Professional resume (Please upload a resume of your educational attainment and working experience)
                    <input
                        type="file"
                        accept=".pdf"
                        hidden
                        onChange={e => props.handleFileChange(e, true)}
                        ref={props.fileInputRef}
                    />
                </Button>
                {props.resumeError && (
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} textAlign="center">
                            <Typography variant="body2" color="error">
                                <strong>Error: {props.resumeError}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                )}
                {props.emptyFormProps.includes('professional_resume_base64') && (
                    <>
                        <Grid container justifyContent="center" alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography variant="body1">
                                    <strong style={{ color: '#d32f2f' }}>This field is required</strong>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider
                            variant="fullWidth"
                            sx={{ backgroundColor: '#6c94a6', mb: 2, height: '1.75px' }}
                        />
                    </>
                )}
                {props.fileResume && (
                    <>
                        <Grid container justifyContent="center" alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography variant="body2">
                                    <strong>{props.fileResume.name}</strong>
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title="Remove file">
                                    <IconButton onClick={() => props.handleFileRemove(true)} sx={{ color: '#d32f2f' }}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                                {props.isEdit && (
                                    <IconButton onClick={() => props.handleFileView(props.fileResume, true)}>
                                        View
                                    </IconButton>
                                )}
                            </Grid>
                        </Grid>
                        <Divider
                            variant="fullWidth"
                            sx={{ backgroundColor: '#6c94a6', mb: 2, height: '1.75px' }}
                        />
                    </>
                )}
            </Grid>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    component="label"
                    startIcon={<UploadFile />}
                    fullWidth
                    sx={{ textTransform: 'none', marginBottom: '2.5vh' }}
                >
                    Professional endorsement (Please upload one letter of reference)
                    <input
                        type="file"
                        hidden
                        accept=".pdf"
                        onChange={e => props.handleFileChange(e, false)}
                        ref={props.fileInputRef}
                    />
                </Button>
                {props.endorsementError && (
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} textAlign="center">
                            <Typography variant="body2" color="error">
                                <strong>Error: {props.endorsementError}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                )}
                {props.emptyFormProps.includes('professional_endorsment_base64') && (
                    <>
                        <Grid container justifyContent="center" alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography variant="body1">
                                    <strong style={{ color: '#d32f2f' }}>This field is required</strong>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider
                            variant="fullWidth"
                            sx={{ backgroundColor: '#6c94a6', mb: 2, height: '1.75px' }}
                        />
                    </>
                )}
                {props.fileEndorsment && (
                    <>
                        <Grid container justifyContent="center" alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography variant="body2">
                                    <strong>{props.fileEndorsment.name}</strong>
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title="Remove file">
                                    <IconButton onClick={() => props.handleFileRemove(false)} sx={{ color: '#d32f2f' }}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                                {props.isEdit && (
                                    <IconButton onClick={() => props.handleFileView(props.fileEndorsment, false)}>
                                        View
                                    </IconButton>
                                )}
                            </Grid>
                        </Grid>
                        <Divider
                            variant="fullWidth"
                            sx={{ backgroundColor: '#6c94a6', mb: 2, height: '1.75px' }}
                        />
                    </>
                )}
            </Grid>
            <Grid item xs={12} sm={12}>
                <TextField
                    placeholder="Please provide information of your professional society memberships"
                    label="Professional society membership"
                    id="outlined-size-small"
                    name="professional_society_membership"
                    multiline
                    rows={5}
                    maxRows={10}
                    fullWidth
                    value={props.formData.professional_society_membership}
                    onChange={e => props.handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    helperText={props.emptyFormProps.includes('professional_society_membership') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('professional_society_membership')}
                />
            </Grid>
        </Grid>
    );
}
export default MotivationStep;